import { FloatLabel } from "primereact/floatlabel";

import commonStyle from "../../content/CommonStyles.module.css";
import { InputNumber } from "primereact/inputnumber";

const NumberInput = ({label, value, onChange, errors, touched, mandatory, customStyle, digits=2}) => {
    return (
        <div className={`${commonStyle.formInput} ${customStyle}`}>
            <div className="p-inputgroup flex-column">
                <FloatLabel>
                    <InputNumber
                        name={label}
                        value={value}
                        useGrouping={false} 
                        maxFractionDigits={digits}
                        onChange={(e) => onChange(e.value)}
                        className={errors && touched ? 'p-invalid' : ''}
                    />
                    <label>{label}{mandatory && <span className={commonStyle.requiredAsterisk}>*</span>}</label>
                </FloatLabel>
                {errors && touched && (<small className={commonStyle.errorSmall}>{errors}</small>)}
            </div>
        </div>   
    );
}

export default NumberInput